import React, { Component, Fragment } from 'react';
import { Checkbox, Form, List, Select } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import qs from 'query-string';
import $ from 'jquery';
import { __ } from '@wordpress/i18n';

import './styles.module.scss';
import Pagination from 'components/Pagination/Pagination';
import AppHelper from 'libs/AppHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';

const Locale = _.get(window, 'VC_CONFIG.Locale');
const VC_CONFIG = _.get(window, 'VC_CONFIG');
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
};

const NewsMode = {
  Banner: 1, // 首頁大版位Banner 前5則
  Carousel: 2, // 首頁中版位Banner 前5則
  List: 3, // 首頁圖文清單  前5則
  TextOnlyList: 4, // 首頁文字清單 前5則 （最新消息、重要公告）
  Table: 5, // 文字清單包含分頁
  Grid: 6, // 圖文清單
  ByQuery: 7, // 依據URL Query決定
  Grid2: 8, // 購物中心圖文清單，會依照個數變換顯示
  News: 9, // 最新消息/news內頁
  shopping: 10, //美食購物Banner 取第一筆
  Life: 11, // 生活專欄/life內頁
};

function isMobile() {
  var mobileDevices = ['Android', 'iPhone', 'iPad'];
  return mobileDevices.some(function(device) {
    return navigator.userAgent.match(device);
  });
}

let swiper55 = null;
let swiper128 = null;
let swiper132 = null;

const tabList = [
  {
    name: '品酒初學',
    bannerImg: `${VC_CONFIG.PLUGIN_ASSETS_URL}img/banner/news/banner5.jpg`,
  },
  {
    name: '夯品開箱',
    bannerImg: `${VC_CONFIG.PLUGIN_ASSETS_URL}img/banner/news/banner2.jpg`,
  },
  {
    name: '美好生活',
    bannerImg: `${VC_CONFIG.PLUGIN_ASSETS_URL}img/banner/news/banner3.jpg`,
  },
  {
    name: '健康樂活',
    bannerImg: `${VC_CONFIG.PLUGIN_ASSETS_URL}img/banner/news/banner6.jpg`,
  },
];

// 前端頁面
export default class NewsList extends Component {
  state = {
    mode: '',
    cname: '品酒初學',
    listInfo: {},
    categoryList: [],
  };

  componentDidMount() {
    AppHelper.updateConfig();
    this.loadData();
    this.fetchmode();
    this.GTM();
    this.fetchCategoryList();

    // let mode = this.props.mode;
    // if (isMobile() && mode === NewsMode.Grid2) {
    //   document.querySelector(".shopping-mall-banner").style.display = "none";
    // }
  }

  GTM = () => {
    var dataLayer = window.dataLayer || [];
    $(document)
      .off('click', '#Banner-M div a')
      .on('click', '#Banner-M div a', function() {
        var $text = $(this).attr('alt');
        dataLayer.push({
          event: 'Banner-M_click',
          item: $text,
        });
      });
    $(document)
      .off('click', '#List ul li a')
      .on('click', '#List ul li a', function() {
        var $text = $(this).attr('alt');
        dataLayer.push({
          event: 'news_click',
          item: $text,
        });
      });
    $(document)
      .off('click', '#TextOnlyList ul li a')
      .on('click', '#TextOnlyList ul li a', function() {
        var $text = $(this).attr('alt');
        dataLayer.push({
          event: 'news_click',
          item: $text,
        });
      });
    $(document).on('click', '#Banner div iframe', function() {
      var $text = $(this).attr('alt');
      dataLayer.push({
        event: 'Banner_youtube_click',
        item: $text,
      });
    });
  };

  fetchCategoryList = () => {
    const mode = _.get(this, 'props.mode');
    // 只有購物中心要處理
    if ([NewsMode.Grid2].indexOf(mode) < 0) {
      return;
    }

    whttp.get(
      `${API_HOST}/api/v1/news`,
      { page: 1, page_size: 'all' },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;
        if (state === false || code !== 200) return;
        this.setState({ categoryList: data.rows }, () => {
          const { categoryList } = this.state;

          if (mode === NewsMode.Grid2) {
            const category55 = categoryList.filter((c) => c.category_id === 55); //活動快訊
            const category128 = categoryList.filter(
              (c) => c.category_id === 128
            ); //新櫃登場
            const category132 = categoryList.filter(
              (c) => c.category_id === 132
            ); //期間限定

            if (category55.length === 0) {
              document.querySelector('.category55').style.display = 'none';
            } else {
              document.querySelector('.category55').style.display = 'block';
              this.reloadSwiperShoppingMall55();
            }

            if (category128.length === 0) {
              document.querySelector('.category128').style.display = 'none';
            } else {
              document.querySelector('.category128').style.display = 'block';
              this.reloadSwiperShoppingMall128();
            }

            if (category132.length === 0) {
              document.querySelector('.category132').style.display = 'none';
            } else {
              document.querySelector('.category132').style.display = 'block';
              this.reloadSwiperShoppingMall132();
            }

            const categoryIgList = categoryList.filter(
              (c) =>
                c.category_id ===
                (API_HOST === 'https://testwww.uni-prosperity.com.tw/console'
                  ? 128
                  : 131)
            );
            const igListSorted = categoryIgList
              .filter((c) => c.status)
              .sort((a, b) => {
                return (
                  Math.abs(Date.parse(new Date()) - Date.parse(a.start_date)) -
                  Math.abs(Date.parse(new Date()) - Date.parse(b.start_date))
                );
              });
            console.log('igListSorted', igListSorted);
            if (igListSorted[0]) {
              const igEmbedCode = igListSorted[0].ig;
              const igWrapperEl = document.querySelector('.ig-wrapper');
              igWrapperEl.innerHTML = igEmbedCode;
              igWrapperEl.style.display = 'block';
              igWrapperEl.style.width = isMobile() ? '100%' : '350px';
              window.instgrm && window.instgrm.Embeds.process();
            }
          }
        });
      }
    );
  };

  loadData = (opt) => {
    const query = AppHelper.getURLQuery();
    const mode = _.get(this, 'props.mode');
    const category_ids =
      mode !== NewsMode.ByQuery ||
      mode !== NewsMode.News ||
      mode !== NewsMode.Life
        ? _.get(this, 'props.category_ids')
        : undefined;
    let category_name =
      mode === NewsMode.ByQuery ||
      mode === NewsMode.News ||
      mode === NewsMode.Life
        ? _.get(query, 'cname', '注目活動')
        : undefined;
    // 如果 category_name 以 'uniopen' 開頭，去除 'uniopen' 字樣
    if (typeof category_name === 'string' && category_name.startsWith('uniopen')) {
      category_name = category_name.replace(/^uniopen/, '');
    }
    var size = 'all';
    // 減少前端顯示筆數以加快速度
    switch (mode) {
      case NewsMode.News:
        size = 10;
        break;
      case NewsMode.TextOnlyList:
        size = isMobile() ? 2 : 5;
        break;
      default:
        break;
    }
    const params = {
      page: _.get(opt, 'page', 1),
      page_size: _.get(opt, 'pageSize', size),
      'category_ids[]': category_ids,
      category_name,
      mode: mode,
    };

    switch (mode) {
      case NewsMode.List:
        params.is_middle_banner = 0;
        break;
      case NewsMode.Carousel:
        params.is_middle_banner = 1;
        break;
      default:
        break;
    }

    const queryString = qs.stringify(params, { skipNull: true });
    whttp.sharedGet(
      `${API_HOST}/api/v1/news?${queryString}`,
      null,
      (state, res) => {
        console.log(`news = ${queryString}`, res);
        const { code = 100, reason = '發生錯誤', data = {} } = res;
        if (state === false || code !== 200) return;
        console.log(`${API_HOST}/api/v1/news?${queryString}`, data);
        this.setState(
          {
            listInfo: data,
            categories: _.get(data, 'categories'),
          },
          () => {
            this.reloadSwiper();
          }
        );
      }
    );
  };

  reloadSwiper = _.debounce(() => {
    const Swiper = window.Swiper;
    if (!Swiper) return;
    var swiperKV = new Swiper('.KV-swiper', {
      autoplay: true,
      loop: true,
      speed: 800,
      navigation: {
        nextEl: '.KV-swiper-button-next',
        prevEl: '.KV-swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    var swiperAD = new Swiper('.AD-banner-swiper', {
      autoplay: true,
      loop: true,
      speed: 800,
      pagination: {
        el: '.AD-banner-swiper-pagination',
        clickable: true,
      },
    });
  }, 500);

  // forMobile 首頁、Shopping mall活動快訊
  reloadSwiper2 = _.debounce(() => {
    const Swiper = window.Swiper;
    if (!Swiper) return;

    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)');
    let tablet = window.matchMedia(
      '(min-width: 767px) and (max-width: 1024px)'
    );
    let desktop = window.matchMedia('(min-width: 1025px)');

    new Swiper('.swiper-container1', {
      initialSlide: 0,
      spaceBetween: 10,
      loop: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }, 500);

  reloadSwiperShoppingMall55 = _.debounce(() => {
    const Swiper = window.Swiper;
    if (!Swiper || swiper55) return;
    swiper55 = new Swiper(`.swiper-container-55`, {
      initialSlide: 0,
      spaceBetween: 10,
      loop: true,
      slidesPerView: 'auto',
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: `.swiper-container-55 .swiper-pagination`,
        clickable: true,
      },
    });
  }, 500);

  reloadSwiperShoppingMall128 = _.debounce(() => {
    const Swiper = window.Swiper;
    if (!Swiper || swiper128) return;
    swiper128 = new Swiper(`.swiper-container-128`, {
      initialSlide: 0,
      spaceBetween: 10,
      loop: true,
      slidesPerView: 'auto',
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: `.swiper-container-128 .swiper-pagination`,
        clickable: true,
      },
    });
  }, 500);

  reloadSwiperShoppingMall132 = _.debounce(() => {
    const Swiper = window.Swiper;
    if (!Swiper || swiper132) return;
    swiper132 = new Swiper(`.swiper-container-132`, {
      initialSlide: 0,
      spaceBetween: 10,
      loop: true,
      slidesPerView: 'auto',
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: `.swiper-container-132 .swiper-pagination`,
        clickable: true,
      },
    });
  }, 500);

  getNewsLink = (newsInfo) => {
    const action_type = _.get(newsInfo, 'action_type');
    const post_id = _.get(newsInfo, 'post_id');
    let INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
    if (action_type == 1) {
      //let En_Post = _.get(window, "VC_CONFIG.En_Post");
      if (Locale == 'en_US') return `${INDEX_URL}/en-post?postid=${post_id}`;
      else return `${INDEX_URL}?p=${post_id}`;
    }

    if (action_type == 2) {
      const link = _.get(newsInfo, 'link');
      if (!_.isEmpty(link)) return link;
      // return `${VC_CONFIG.INDEX_URL}/news-info/?id=${newsInfo.id}`
    }
    return '#';
  };

  getMode = () => {
    return _.get(this, 'props.mode', NewsMode.Carousel);
  };

  fetchmode = () => {
    var getUrlString = window.location.href;
    var url = new URL(getUrlString);
    this.setState({
      mode: url.searchParams.get('mode'),
      cname: url.searchParams.get('cname'),
    });
  };

  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth;
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line');

    if (!_.get($magicLine, 0)) {
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>");
    }
    /* Cache it */
    $magicLine = $('#magic-line');

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width());

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this);
          leftPos = $el.position().left;
          newWidth = $el.parent().width();

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          });
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          });
        }
      );

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave');
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item');
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item');
      });
  };

  render() {
    const options = _.get(this, 'props.app.options', {});
    let mode = _.get(this, 'props.mode', NewsMode.Carousel);
    let category_ids = _.get(this, 'props.category_ids');

    if (mode === NewsMode.ByQuery) {
      const query = AppHelper.getURLQuery();
      mode = parseInt(_.get(query, 'mode', NewsMode.Grid), 10);
    }

    const listInfo = _.get(this, 'state.listInfo');
    const list = _.get(listInfo, 'rows', []).filter(
      (item) => category_ids.indexOf(item.category_id) !== -1
    );
    const news_categories = _.get(options, 'news_categories', []).filter(
      (item) => category_ids.indexOf(item.id) !== -1
    );

    let selectedCategoryId = _.get(
      this,
      'state.selectedCategoryId',
      _.get(news_categories, '0.id')
    );

    let selectedCategoryName = _.get(
      this,
      'state.selectedCategoryName',
      _.get(news_categories, '0.name')
    );

    var news_url = _.get(window, 'VC_CONFIG.INDEX_URL') + '/news';
    if (Locale == 'en_US') {
      news_url = _.get(window, 'VC_CONFIG.INDEX_URL') + '/news-en';
    }

    var life_url = _.get(window, 'VC_CONFIG.INDEX_URL') + '/life';
    if (Locale == 'en_US') {
      life_url = _.get(window, 'VC_CONFIG.INDEX_URL') + '/life-en';
    }

    if (mode === NewsMode.Banner) {
      return (
        <Fragment>
          <div class='KV-banner'>
            {_.map(list, (item, idx) => (
              <div id='Banner'>
                {idx == 0 &&
                  ((item.youtube && (
                    <div
                      class='jumbotron wp-block-cec-vulcan-block-news-list'
                      vu-attributes='{"mode":1,"category_ids":[50]}'
                    >
                      <div class='KV-banner'>
                        <div class='kv-title' style={{ top: '50%' }}>
                          {item.name}
                          <span class='kv-sub-title'>{item.desc}</span>
                        </div>
                        <iframe
                          alt={item.name}
                          id='player'
                          title='player'
                          class='w-100 h-100'
                          src={
                            _.get(item, 'youtube') +
                            '?frameborder=0&modestbranding=1&controls=0&rel=0&autoplay=0&enablejsapi=1'
                          }
                          allow='accelerometer;autohide; encrypted-media; gyroscope; picture-in-picture'
                          allowfullscreen=''
                        />
                      </div>
                    </div>
                  )) ||
                    (!item.youtube && (
                      <div class='KV-banner'>
                        <div class='kv-title' style={{ top: '50%' }}>
                          {item.name}
                          <span class='kv-sub-title'>{item.desc}</span>
                        </div>
                        <img
                          src={_.get(item, 'images.0.url')}
                          alt={item.name}
                        />
                      </div>
                    )))}
              </div>
            ))}
          </div>
          {/* </div> */}
        </Fragment>
      );
    }
    if (mode === NewsMode.Carousel) {
      return (
        <Fragment>
          <div class='swiper-container AD-banner-swiper'>
            <div id='Banner-M' class='swiper-wrapper'>
              {_.map(
                list,
                (item, idx) =>
                  item.is_middle_banner == 1 && (
                    <div class='swiper-slide'>
                      <a
                        class='banner-item'
                        role='button'
                        alt={`${item.category_name}-${item.name}`}
                        href={this.getNewsLink(item)}
                        onClick={(e) => {
                          if (this.getNewsLink(item) === '#') {
                            e.preventDefault();
                          }
                        }}
                      >
                        <div
                          class='img-2-1'
                          style={{
                            backgroundImage: `url(${_.get(
                              item,
                              'images.0.url'
                            )})`,
                          }}
                        />
                      </a>
                    </div>
                  )
              )}
            </div>
          </div>
          <div class='AD-banner-swiper-pagination' />
        </Fragment>
      );
    }
    if (mode === NewsMode.List) {
      return (
        <Fragment>
          <div class='card-header tag-tabs'>
            <nav class='tabs-wrap'>
              <ul class='tabs-content'>
                {_.map(news_categories, (categoryInfo) => (
                  <li
                    className={
                      categoryInfo.id === selectedCategoryId
                        ? 'current_page_item'
                        : null
                    }
                    onClick={() =>
                      this.setState({
                        selectedCategoryId: categoryInfo.id,
                        selectedCategoryName: categoryInfo.name,
                      })
                    }
                  >
                    <a alt={categoryInfo.name} role='button'>
                      {Locale == 'en_US' && categoryInfo.name_en
                        ? categoryInfo.name_en
                        : categoryInfo.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
            <a
              class='h6 text-decoration-none mb-0'
              role='button'
              href={`${VC_CONFIG.INDEX_URL}/news${
                Locale === 'en_US' ? '-en' : ''
              }?mode=6&cname=${selectedCategoryName}`}
              data-toggle='tooltip'
              data-placement='right'
              title='看更多'
            >
              <i class='icon-plus' />
            </a>
          </div>

          <div id='List' class='card-body pb-0'>
            <ul class='list-unstyled list-item'>
              {_.filter(
                list,
                (item) =>
                  item.category_id === selectedCategoryId &&
                  item.is_middle_banner == 0
              )
                .slice(0, 5)
                .map((item) => (
                  <li>
                    <a
                      alt={`${item.category_name}-${item.name}`}
                      role='button'
                      href={this.getNewsLink(item)}
                      onClick={(e) => {
                        if (this.getNewsLink(item) === '#') {
                          e.preventDefault();
                        }
                      }}
                    >
                      <div class='row align-items-center'>
                        <div class='col-md-5'>
                          <div
                            class='img-2-1 mb-lg-0 mb-3'
                            style={
                              _.get(item, 'images_previews.0.url')
                                ? {
                                    backgroundImage: `url(${_.get(
                                      item,
                                      'images_previews.0.url'
                                    )})`,
                                  }
                                : {
                                    backgroundImage: `url(${_.get(
                                      item,
                                      'images.0.url'
                                    )})`,
                                  }
                            }
                          />
                        </div>
                        <div class='col-md'>
                          <div class='py-2'>
                            <h5 class='text-navy fw-700 limit-line-1 flex-fill mb-2 h6'>
                              {item.name}
                            </h5>
                            <span class='fw-300 text-body text-justify limit-line-2 mb-2 p'>
                              {item.desc}
                            </span>
                            <span class='text-navy text-nowrap d-block mb-0 note'>
                              {item.start_date} - {item.end_date}
                            </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                ))}
              <li>
                <div class='d-flex justify-content-end py-3'>
                  <a
                    class='fw-700 mb-0 text-navy d-inline-flex align-items-center line-hight-fit p'
                    role='button'
                    href={`${VC_CONFIG.INDEX_URL}/news${
                      Locale === 'en_US' ? '-en' : ''
                    }?mode=6&cname=${selectedCategoryName}`}
                  >
                    {Locale === 'en_US' ? 'more' : '更多活動'}
                    <i class='text-primary fas fa-chevron-circle-right line-hight-fit mb-0 ml-2' />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </Fragment>
      );
    }
    if (mode === NewsMode.TextOnlyList) {
      return (
        <Fragment>
          {_.map(news_categories, (categoryInfo) => (
            <div class='card card-border-primary shadow-0 mb-5'>
              <div class='card-header d-flex justify-content-between align-items-center'>
                {' '}
                <strong class='h6 fw-700 mb-0'>
                  {Locale == 'en_US' && categoryInfo.name_en
                    ? categoryInfo.name_en
                    : categoryInfo.name}
                </strong>
                <a
                  class='h6 text-decoration-none mb-0'
                  role='button'
                  href={`${VC_CONFIG.INDEX_URL}/news${
                    Locale === 'en_US' ? '-en' : ''
                  }/?mode=${NewsMode.TextOnlyList}&cname=${categoryInfo.name}`}
                  data-toggle='tooltip'
                  data-placement='right'
                  title='看更多'
                >
                  <i class='icon-plus' />
                </a>
              </div>
              <div id='TextOnlyList' class='card-body py-0'>
                <ul class='list-unstyled list-item'>
                  {!isMobile() &&
                    _.filter(
                      list,
                      (item) => item.category_id === categoryInfo.id
                    )
                      .slice(0, 5)
                      .map((item) => (
                        <li>
                          <a
                            alt={`${item.category_name}-${item.name}`}
                            role='button'
                            href={this.getNewsLink(item)}
                            onClick={(e) => {
                              if (this.getNewsLink(item) === '#') {
                                e.preventDefault();
                              }
                            }}
                          >
                            <div class='d-flex justify-content-between align-items-center text-navy mb-3'>
                              <h5 class='p fw-700 limit-line-1 text-highlight mb-0 mr-2'>
                                {item.name}
                              </h5>
                              <span class='p text-nowrap mb-0 ml-auto'>
                                {item.start_date &&
                                  moment(item.start_date).format('YYYY-MM-DD')}
                              </span>
                            </div>
                            <span class='note fw-300 text-body text-justify limit-line-2 mb-0'>
                              {' '}
                              {item.desc}
                            </span>
                          </a>
                        </li>
                      ))}
                  {isMobile() &&
                    _.filter(
                      list,
                      (item) => item.category_id === categoryInfo.id
                    )
                      .slice(0, 2)
                      .map((item) => (
                        <li>
                          <a
                            alt={`${item.category_name}-${item.name}`}
                            role='button'
                            href={this.getNewsLink(item)}
                            onClick={(e) => {
                              if (this.getNewsLink(item) === '#') {
                                e.preventDefault();
                              }
                            }}
                          >
                            <div class='d-flex justify-content-between align-items-center text-navy mb-3'>
                              <h5 class='p fw-700 limit-line-1 text-highlight mb-0 mr-2'>
                                {item.name}
                              </h5>
                              <span class='p text-nowrap mb-0 ml-auto'>
                                {item.start_date &&
                                  moment(item.start_date).format('YYYY-MM-DD')}
                              </span>
                            </div>
                            <span class='note fw-300 text-body text-justify limit-line-2 mb-0'>
                              {' '}
                              {item.desc}
                            </span>
                          </a>
                        </li>
                      ))}
                </ul>
              </div>
            </div>
          ))}
        </Fragment>
      );
    }
    if (mode === NewsMode.Table) {
      return (
        <div class='container'>
          {_.map(_.get(listInfo, 'rows'), (item, idx) => (
            <Fragment>
              {item.category_id == 45 && idx == 0 && (
                <div class='px-4 p-3 px-md-5 bg-primary d-none d-lg-block' style={{ backgroundColor: '#2B61AF' }}>
                  <div class='row align-items-center p-1'>
                    <div class='col-lg-2'>
                      <h6 class='h5 text-white mb-0'>
                        {__('公佈日期', 'cec-plugin-stores')}
                      </h6>
                    </div>
                    <div class='col-lg'>
                      <h6 class='h5 text-white mb-0'>
                        {__('活動名稱', 'cec-plugin-stores')}
                      </h6>
                    </div>
                  </div>
                </div>
              )}
              <hr class='border-top border-primary m-0' />
              <a
                class='px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list'
                role='button'
                href={this.getNewsLink(item)}
                onClick={(e) => {
                  if (this.getNewsLink(item) === '#') {
                    e.preventDefault();
                  }
                }}
              >
                {item.category_id == 45 && (
                  <div class='row align-items-center p-1'>
                    <div class='col-lg-2'>
                      <h6 class='h6 text-navy mb-0' data-title='公佈日期'>
                        {item.show_at.substring(0, 10)}
                      </h6>
                    </div>
                    <div class='col-lg'>
                      <h6 class='h6 text-navy mb-0' data-title='活動名稱'>
                        {item.name}
                      </h6>
                    </div>
                  </div>
                )}
                {item.category_id != 45 && (
                  <div class='row align-items-center'>
                    <div class='col-md-3'>
                      <h6 class='h5 text-navy mb-0'>{item.name}</h6>
                    </div>
                    <div class='col-auto'>
                      <h6 class='h5 text-navy mb-0'>
                        {item.start_date} - {item.end_date}
                      </h6>
                    </div>
                    <div class='col-auto ml-auto mt-md-0 mt-4'>
                      <p class='h6 text-primary mb-0'>
                        {item.start_date}
                        <span class='ml-2'>
                          {__('發佈', 'cec-plugin-stores')}
                        </span>
                      </p>
                    </div>
                  </div>
                )}
              </a>
            </Fragment>
          ))}
          <hr class='border-top border-primary m-0' />

          <Pagination
            current={_.get(listInfo, 'current', 0)}
            pageSize={_.get(listInfo, 'page_size', 10)}
            total={_.get(listInfo, 'total', 0)}
            onChange={(page, pageSize) => {
              this.loadData({ page, pageSize });
            }}
          />
        </div>
      );
    }
    if (mode === NewsMode.Grid) {
      return (
        <div class='container'>
          <div class='row no-gutters mx-n3'>
            {_.map(_.get(listInfo, 'rows'), (item) => (
              <Fragment>
                <div class='col-lg-6 px-3 my-3'>
                  <a
                    class='card card-event'
                    role='button'
                    href={this.getNewsLink(item)}
                    onClick={(e) => {
                      if (this.getNewsLink(item) === '#') {
                        e.preventDefault();
                      }
                    }}
                  >
                    <div
                      class='img-2-1 card-img-top bg-contain'
                      style={{
                        backgroundImage: `url(${_.get(
                          item,
                          'images_previews.0.url'
                        )})`,
                      }}
                    />
                    <div class='card-body'>
                      <div class='d-flex justify-content-between align-items-center mb-3'>
                        <h5 class='h5 text-navy limit-line-1 mb-0'>
                          {item.name}
                        </h5>
                        <span class='note text-dark mb-0 text-nowrap'>
                          {item.start_date}-{item.end_date}
                        </span>
                      </div>
                      <p class='p text-dark limit-line-1 mb-0'>{item.desc}</p>
                    </div>
                  </a>
                </div>
              </Fragment>
            ))}
          </div>
          <Pagination
            current={_.get(listInfo, 'current', 0)}
            pageSize={_.get(listInfo, 'page_size', 10)}
            total={_.get(listInfo, 'total', 0)}
            onChange={(page, pageSize) => {
              this.loadData({ page, pageSize });
            }}
          />
        </div>
      );
    }
    if (mode === NewsMode.Grid2) {
      const rows = listInfo.rows || [];
      return (
        <div
          class={`swiper-container-${this.props.category_ids[0]}`}
          style={{ overflow: 'hidden' }}
        >
          <div class='swiper-wrapper' style={{ height: 'fit-content' }}>
            {rows.map((item, idx) => {
              return (
                <div key={idx} class='swiper-slide'>
                  <a
                    class='card text-decoration-none border-0 shadow-0 p-0'
                    role='button'
                    href={this.getNewsLink(item)}
                    onClick={(e) => {
                      if (this.getNewsLink(item) === '#') {
                        e.preventDefault();
                      }
                    }}
                  >
                    <div
                      class='img-2-1'
                      style={{
                        backgroundImage: `url(${_.get(item, 'images.0.url')})`,
                      }}
                    />
                    <div class='card-body p-3'>
                      <h5 class='text-navy limit-line-1 mb-2 h6'>
                        {item.name}
                      </h5>
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
          <div class={`swiper-pagination`} />
        </div>
      );
    }
    if (mode === NewsMode.Grid2) {
      const rows = listInfo.rows || [];
      return (
        <Fragment>
          <div class='event-card-scroll_mobile mb-md-0 mb-5 swiper-container'>
            <div class='row no-gutters mx-n3 w-auto swiper-wrapper'>
              {_.map(rows, (item, idx) => {
                return (
                  <div
                    key={idx}
                    class='col-auto col-md-12 px-3 mb-4 swiper-slide'
                  >
                    <a
                      class='card text-decoration-none border-0 shadow-0 p-0'
                      role='button'
                      href={this.getNewsLink(item)}
                      onClick={(e) => {
                        if (this.getNewsLink(item) === '#') {
                          e.preventDefault();
                        }
                      }}
                    >
                      <div
                        class='img-2-1'
                        style={{
                          backgroundImage: `url(${_.get(
                            item,
                            'images.0.url'
                          )})`,
                        }}
                      />
                      <div class='card-body p-3'>
                        <h5 class='text-navy limit-line-1 mb-2 h6'>
                          {item.name}
                        </h5>
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
            <div class='swiper-pagination' />
          </div>
        </Fragment>
      );
    }
    if (mode === NewsMode.News) {
      const rows = _.get(listInfo, 'rows', []);
      return (
        <main class='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${VC_CONFIG.INDEX_URL}${
                        Locale == 'en_US' ? '/en' : ''
                      }`}>
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a
                      // href='javascript:void(0)'
                      onClick={(e) => e.preventDefault()}>
                      {__('最新消息', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {this.state.cname && (
                    <li class='breadcrumb-item active' aria-current='page'>
                      {__(`${this.state.cname}`, 'cec-plugin-stores')}
                    </li>
                  )}
                </ol>
              </nav>
            </div>
          </div>
          <div class='banner banner-news'>
            <div class='container'>
              <div class='banner-image'>
                <img
                  src={`${
                    VC_CONFIG.PLUGIN_ASSETS_URL
                  }img/banner/news/event.svg`}
                  alt=''
                />
                {this.state.cname && (
                  <h3 class='title'>
                    {__(`${this.state.cname}`, 'cec-plugin-stores')}
                  </h3>
                )}
              </div>
            </div>
          </div>
          <div class='mb-5 basic-tabs-label'>
            <ul class='nav nav-pills' id='pills-tab'>
              <li
                class={
                  this.state.cname && this.state.cname == '量販活動'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=6&cname=量販活動`}>
                  {__('量販活動', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '超市活動'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=6&cname=超市活動`}>
                  {__('超市活動', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '會員活動'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=6&cname=會員活動`}>
                  {__('會員活動', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == 'uniopen聯名卡活動'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a
                  class='nav-link'
                  href={`${news_url}/?mode=6&cname=uniopen聯名卡活動`}>
                  {__('uniopen聯名卡活動', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '新聞中心'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=4&cname=新聞中心`}>
                  {__('新聞中心', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '公告訊息'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=4&cname=公告訊息`}>
                  {__('公告訊息', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '得獎公告'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=5&cname=得獎公告`}>
                  {__('得獎公告', 'cec-plugin-stores')}
                </a>
              </li>
            </ul>
          </div>
          {this.state.mode == 6 && (
            <div class='container'>
              <div class='row no-gutters mx-n3'>
                {_.map(_.get(listInfo, 'rows'), (item) => (
                  <Fragment>
                    <div class='col-lg-6 px-3 my-3'>
                      <a
                        class='card card-event'
                        role='button'
                        href={this.getNewsLink(item)}
                        onClick={(e) => {
                          if (this.getNewsLink(item) === '#') {
                            e.preventDefault()
                          }
                        }}
                        target={item.action_type == 2 ? '_blank' : '_self'}>
                        <div
                          class='img-2-1 card-img-top bg-contain'
                          style={
                            _.get(item, 'images_previews.0.url')
                              ? {
                                  backgroundImage: `url(${_.get(
                                    item,
                                    'images_previews.0.url',
                                  )})`,
                                }
                              : {
                                  backgroundImage: `url(${_.get(
                                    item,
                                    'images.0.url',
                                  )})`,
                                }
                          }
                        />
                        <div
                          class='card-body'
                          style={{
                            padding: ' 1rem 2rem',
                          }}>
                          <div class='d-flex justify-content-between align-items-center mb-3'>
                            <h5 class='h5 text-navy limit-line-1 mb-0'>
                              {item.name}
                            </h5>
                            <span class='note text-dark mb-0 text-nowrap'>
                              {item.start_date}-{item.end_date}
                            </span>
                          </div>
                          <p class='h6 text-font limit-line-2 mb-0'>
                            {item.desc}
                          </p>
                        </div>
                      </a>
                    </div>
                  </Fragment>
                ))}
              </div>
              <Pagination
                current={_.get(listInfo, 'current', 0)}
                pageSize={_.get(listInfo, 'page_size', 10)}
                total={_.get(listInfo, 'total', 0)}
                onChange={(page, pageSize) => {
                  this.loadData({
                    page,
                    pageSize,
                  })
                  window.scrollTo(0, 0)
                }}
              />
            </div>
          )}
          {(this.state.mode == 5 || this.state.mode == 4) && (
            <div class='container'>
              <div
                class='px-4 p-3 px-md-5 bg-primary d-none d-lg-block'
                style={{ backgroundColor: '#2B61AF' }}>
                <div class='row align-items-center p-1'>
                  <div class='col-lg-2'>
                    <h6 class='h5 text-white mb-0'>
                      {__('公佈日期', 'cec-plugin-stores')}
                    </h6>
                  </div>
                  <div class='col-lg'>
                    <h6 class='h5 text-white mb-0'>
                      {this.state.mode == 5
                        ? __('活動名稱', 'cec-plugin-stores')
                        : __('消息名稱', 'cec-plugin-stores')}
                    </h6>
                  </div>
                </div>
              </div>
              {_.map(_.get(listInfo, 'rows'), (item, idx) => (
                <Fragment>
                  <div>
                    <hr class='border-top border-primary m-0' />
                    <a
                      class='px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list'
                      role='button'
                      href={this.getNewsLink(item)}
                      onClick={(e) => {
                        if (this.getNewsLink(item) === '#') {
                          e.preventDefault()
                        }
                      }}>
                      <div class='row align-items-center p-1'>
                        <div class='col-lg-2'>
                          <h6 class='h6 text-navy mb-0' data-title='公佈日期'>
                            {item.show_at.substring(0, 10)}
                          </h6>
                        </div>
                        <div class='col-lg'>
                          <h6 class='h6 text-navy mb-0' data-title='活動名稱'>
                            {item.name}
                          </h6>
                        </div>
                      </div>
                    </a>
                  </div>
                </Fragment>
              ))}
              <hr class='border-top border-primary m-0' />
              <Pagination
                current={_.get(listInfo, 'current', 0)}
                pageSize={_.get(listInfo, 'page_size', 10)}
                total={_.get(listInfo, 'total', 0)}
                onChange={(page, pageSize) => {
                  this.loadData({
                    page,
                    pageSize,
                  })
                  window.scrollTo(0, 0)
                }}
              />
            </div>
          )}
        </main>
      )
    }
    if (mode === NewsMode.shopping) {
      return (
        <Fragment>
          <div class='banner-image'>
            {list && _.get(_.head(list), 'images.0.url') && (
              <img src={`${_.get(_.head(list), 'images.0.url')}`} alt='' />
            )}
            {(!list || !_.get(_.head(list), 'images.0.url')) && (
              <img
                src={`${
                  VC_CONFIG.INDEX_URL
                }/wp-content/themes/cec/assets/img/banner/mall/banner-mall2.jpeg`}
                alt=''
              />
            )}
          </div>
        </Fragment>
      );
    }
    if (mode === NewsMode.Life) {
      return (
        <main class='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${VC_CONFIG.INDEX_URL}${
                        Locale == 'en_US' ? '/en' : ''
                      }`}
                    >
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a
                      // href='javascript:void(0)'
                      onClick={(e) => e.preventDefault()}
                    >
                      {__('生活專欄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {this.state.cname && (
                    <li class='breadcrumb-item active' aria-current='page'>
                      {__(`${this.state.cname}`, 'cec-plugin-stores')}
                    </li>
                  )}
                </ol>
              </nav>
            </div>
          </div>
          <div class='banner banner-md'>
            <div class='banner-image'>
              <img
                src={tabList.find((t) => t.name === this.state.cname).bannerImg}
                alt=''
              />
              {this.state.cname && (
                <h3 class='title'>
                  {__(`${this.state.cname}`, 'cec-plugin-stores')}
                </h3>
              )}
            </div>
          </div>
          <div class='mb-5 basic-tabs-label'>
            <ul class='nav nav-pills' id='pills-tab'>
              {tabList.map((t, idx) => {
                return (
                  <li
                    key={idx}
                    class={
                      this.state.cname && this.state.cname == t.name
                        ? 'nav-item current_page_item highlight'
                        : 'nav-item'
                    }
                  >
                    <a
                      class='nav-link'
                      href={`${life_url}/?mode=6&cname=${t.name}`}
                    >
                      {__(t.name, 'cec-plugin-stores')}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          {this.state.mode == 6 && (
            <div class='container'>
              <div class='row no-gutters mx-n3'>
                {_.map(_.get(listInfo, 'rows'), (item) => (
                  <Fragment>
                    <div class='col-lg-6 px-3 my-3'>
                      <a
                        class='card card-event'
                        role='button'
                        href={this.getNewsLink(item)}
                        onClick={(e) => {
                          if (this.getNewsLink(item) === '#') {
                            e.preventDefault();
                          }
                        }}
                        target={item.action_type == 2 ? '_blank' : '_self'}
                      >
                        <div
                          class='img-2-1 card-img-top bg-contain'
                          style={
                            _.get(item, 'images.0.url')
                              ? {
                                  backgroundImage: `url(${_.get(
                                    item,
                                    'images.0.url'
                                  )})`,
                                }
                              : {
                                  backgroundImage: `url(${
                                    VC_CONFIG.PLUGIN_ASSETS_URL
                                  }img/news/logo_empty.jpg)`,
                                }
                          }
                        />
                        <div
                          class='card-body'
                          style={{
                            padding: ' 1rem 2rem',
                          }}
                        >
                          <div class='d-flex justify-content-between align-items-center mb-3'>
                            <h5 class='h5 text-navy limit-line-1 mb-0'>
                              {item.name}
                            </h5>
                            <span class='note text-dark mb-0 text-nowrap'>
                              {item.start_date}-{item.end_date}
                            </span>
                          </div>
                          <p class='h6 text-font limit-line-2 mb-0'>
                            {item.desc}
                          </p>
                        </div>
                      </a>
                    </div>
                  </Fragment>
                ))}
              </div>
              <Pagination
                current={_.get(listInfo, 'current', 0)}
                pageSize={_.get(listInfo, 'page_size', 10)}
                total={_.get(listInfo, 'total', 0)}
                onChange={(page, pageSize) => {
                  this.loadData({
                    page,
                    pageSize,
                  });
                  window.scrollTo(0, 0);
                }}
              />
            </div>
          )}
        </main>
      );
    }
    return <Fragment />;
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };
export class NewsListEditor extends Component {
  formRef = React.createRef();
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  };
  componentDidMount() {
    AppHelper.updateConfig();

    this.formRef.current.setFieldsValue(this.props.attributes);
  }
  render() {
    const listInfo = this.state.listInfo;
    const options = _.get(this, 'props.app.options', {});

    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div class='dashicons dashicons-megaphone' />
          </span>
          消息列表
        </div>
        <Form
          ref={this.formRef}
          name='basic'
          className='basicForm'
          layout='vertical'
          // onFinish={values => this.submitData(values)}
          onValuesChange={(changedFields, allFields) =>
            this.props.setAttributes(changedFields)
          }
        >
          <Form.Item {...genFormItemAtrribute('mode', '顯示方式')}>
            <Select>
              <Select.Option value={NewsMode.Banner}>
                首頁大版位Banner
              </Select.Option>
              <Select.Option value={NewsMode.Carousel}>
                首頁中版位Banner
              </Select.Option>
              <Select.Option value={NewsMode.List}>首頁圖文列表</Select.Option>
              <Select.Option value={NewsMode.TextOnlyList}>
                首頁純文字列表
              </Select.Option>
              <Select.Option value={NewsMode.Table}>
                文字清單含分頁
              </Select.Option>
              <Select.Option value={NewsMode.Grid}>圖文清單</Select.Option>
              <Select.Option value={NewsMode.ByQuery}>
                依據URL Query呈現
              </Select.Option>
            </Select>
          </Form.Item>
          {this.formRef.current &&
            this.formRef.current.getFieldValue('mode') !== NewsMode.ByQuery && (
              <Form.Item {...genFormItemAtrribute('category_ids', '顯示類別')}>
                <Checkbox.Group>
                  <List
                    grid={listGrid}
                    dataSource={_.get(options, 'news_categories', [])}
                    renderItem={(item) => (
                      <List.Item>
                        <Checkbox value={item.id}>{item.name}</Checkbox>
                      </List.Item>
                    )}
                  />
                </Checkbox.Group>
              </Form.Item>
            )}
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/news/news-list.js